import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import DigitalProducts from "@/pages/DigitalProducts";
import Resources from "@/pages/Resources";
import Impact from "@/pages/Impact";
import Partnerships from "@/pages/Partnerships";
import BookConsultation from "@/pages/BookConsultation";
import Contact from "@/pages/Contact";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import Disclaimer from "@/pages/legal/Disclaimer";
import Accessibility from "@/pages/legal/Accessibility";
import NotFound from "@/pages/NotFound";

import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/digital-products" element={<DigitalProducts />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/impact" element={<Impact />} />
          <Route path="/partnerships" element={<Partnerships />} />
          <Route path="/book" element={<BookConsultation />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/legal/privacy" element={<Privacy />} />
          <Route path="/legal/terms" element={<Terms />} />
          <Route path="/legal/disclaimer" element={<Disclaimer />} />
          <Route path="/legal/accessibility" element={<Accessibility />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
